// @flow
import { TOUR_PROGRAM } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_TOUR_PROGRAM } from 'Utils/request/requestDictionary';
import { type StopProps } from 'Components/widgets/product-program/ProductProgram.jsx';

type GQlProgramProps = {
  stops?: Array<StopProps>,
  duration?: string,
  title?: string,
};

type CMSProps = {
  resortId: string,
  isDetailed: boolean,
  yourItinerary: string,
  tourDurationPlaceholder: string,
  tourDayPlaceholder: string,
  yourExtension: string,
  extensionDurationPlaceholder: string,
  extensionDayPlaceholder: string,
};

type GQLProps = {
  stopover: {
    tour: GQlProgramProps,
    extension: GQlProgramProps,
  },
};

export type TourProgramDescriptorProps = {
  ...$Exact<CMSProps>,
  ...$Exact<GQLProps>,
};

export const tourProgramResolver = {
  name: TOUR_PROGRAM,
  resolve: (appContext: AppContext, props: CMSProps): Promise<GQLProps> => {
    const {
      resortId: productId,
      yourItinerary,
      tourDurationPlaceholder,
      tourDayPlaceholder,
      yourExtension,
      extensionDurationPlaceholder,
      extensionDayPlaceholder,
    } = props;

    const query = `query {
      stopover(productId:"${productId}"){
        tour{
          title(message:"${yourItinerary}")
          duration(message:"${tourDurationPlaceholder}")
          stops{
            day(message:"${tourDayPlaceholder}")
            title
            description
          }
        }
        extension{
          title(message:"${yourExtension}")
          duration(message:"${extensionDurationPlaceholder}")
          stops{
            day(message:"${extensionDayPlaceholder}")
            title
            description
          }
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_TOUR_PROGRAM,
      strictErrors: false,
    });
  },
};
